import React, { Component } from "react";
import ReactDOM from "react-dom";

import { isMobile } from "../../utils/deviceInfo";
import "./trivia-survey.css";
import "./trivvy-edit-bwai.css";
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Tooltip,
  ButtonDropdown,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";

import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";

import ReactTooltip from "react-tooltip";
import { ImFontSize } from "react-icons/im";
import { GiGears, GiOpenTreasureChest } from "react-icons/gi";
import { MdOutlineQuiz } from "react-icons/md";
import {
  BsAlarmFill,
  BsBrush,
  BsCheckLg,
  BsDownload,
  BsFiles,
  BsFillEyeFill,
  BsFillGearFill,
  BsThreeDots,
} from 'react-icons/bs'
import TriviaEditViewListUI from './Components/TriviaEditViewListUI'
import MessagesEditViewListUI from './Components/MessagesEditViewListUI'

import {
  formatQuestionsNumberWise,
  TRIVIA_DESCRIPTION,
} from "../../utils/constants";
import {
  isRichMessageBody,
  messageTextPreserveSpacing,
  sanitizeMessageBodyHtml,
  trimDisplayText,
} from "../../utils/normalizeText";
import ShareTriviaComponent from "./Components/ShareTriviaComponent";
import debounce from "lodash.debounce";
import TriviaResultsComponent from "./Components/TriviaResultsSection";
import LinkTriviaRewardPopup from "./Components/LinkTriviaRewardPopup";
import DuplicateTriviaPopup from "./Components/DuplicateTriviaPopup";
import {
  applyTrivvyTitleText,
  publishDisabled,
  THEME_SETTING,
  getTrivvyTitleText,
  minPlanLimitCheck,
} from "./data";
import AdvanceTrivvySettingModal from "./Components/AdvanceTrivvySettingModal";
import parse from "html-react-parser";
import RangeInput from "../../components/RangeInput/RangeInput";
import Select from "react-select/lib/Select";
import { toastContainer, dismissToast } from "../../utils/toast";
import { LuPencil } from "react-icons/lu";
import { BiFolder } from "react-icons/bi";
import QuestionsListModal from "./Components/QuestionsListModal";
import NewShareTriviaComponent from "./Components/ShareTrivia/NewShareTriviaComponent";
import ManualRemindersModal from "./Components/ManualRemindersModal";
import { getTextFromLanguageCodeAndKey } from "./languages";
import FolderNameModal from "./Components/FolderNameModal";
import {
  TrivvyMoreActionsItems,
  TrivvyMoreActionsModals,
} from "./Components/TrivvyMoreActions";
import * as folderService from "./Components/folderService";

class TriviaEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // What is being typed into the title pill. getTrivvyTitleText trims, and
      // the input is controlled by it, so round-tripping every keystroke through
      // the stored markup ate a trailing space — you could not type one at all.
      // null means "not editing"; the stored value is shown instead.
      nameDraft: null,
      duplicateModalOpen: false,
      surveyItem: null,
      menu: null,
      isPreview: false,
      moreActionsMobileOpen: false,

      linkedRewards: [],
      linkPopup: false,
      linkedRewards: [],

      advanceSettingsModal: false,
      buttonDrodownOpen: false,
      questionsListModal: false,
      manualReminderModal: false,
      selectedFilters:{},
      
      // Submissions tracking
      submissionsData: [],
      submissionsLoading: false,
      submissionsError: null,

      // "Get Full Insights" expand state for the Message insights card.
      // Held here so it survives top-level menu changes (Edit ↔ Share ↔
      // Results) and the sub-tab changes inside Results, but resets when the
      // user leaves the trivvy entirely (this page unmounts).
      messageInsightsOpen: false,

      // Mobile-only "More actions" bottom-sheet open state (messaging view).
      moreActionsMobileOpen: false,

      // TBV-889: shared "More actions" entries (duplicate / privacy / delete /
      // add-to-folder) re-hosted from the list-row 3-dots menu.
      moreAction: { type: null, item: null },
      folderList: [],
      folderMembership: {},
      folderNameModal: { open: false },
    }
  }

  // Folder category the folder list was last fetched for; keeps menu re-renders
  // and tab switches from re-firing get-folders.
  foldersLoadedFor = null

  folderCategoryFor = (trivvy) => {
    if (!trivvy) {
      return null;
    }
    if (trivvy.isMessaging) {
      return "MESSAGE";
    }
    if (trivvy.triviaCategoryType === "KNOWLEDGE_CHECK") {
      return "KNOWLEDGE_CHECK";
    }
    return "SURVEY";
  };

  loadTrivvyFolders = (trivvy, force) => {
    const category = this.folderCategoryFor(trivvy);
    if (!category) {
      return;
    }
    if (!force && this.foldersLoadedFor === category) {
      return;
    }
    this.foldersLoadedFor = category;
    folderService
      .getFolders(category)
      .then((folders) => {
        this.setState({
          folderList: folders,
          folderMembership: folderService.buildCountMap(folders),
        });
      })
      .catch((err) => {
        // Release the guard so a later open can retry; leaving it set would
        // hide "Add to folder" permanently after one transient failure.
        this.foldersLoadedFor = null;
        console.log("folder list load failed", err);
      });
  };

  openMoreAction = (type) => {
    this.setState({
      moreActionsMobileOpen: false,
      moreAction: { type: type, item: this.props.currentTrivia },
    });
  };

  closeMoreAction = () => {
    this.setState({ moreAction: { type: null, item: null } });
  };

  handleTrivvyDeleted = () => {
    this.closeMoreAction();
    this.menuNav();
  };

  handleTrivvyPrivacyUpdated = (trivvyId, visibility) => {
    const { currentTrivia } = this.props;
    if (currentTrivia && String(currentTrivia._id) === String(trivvyId)) {
      this.props.setCurrentTrivia({
        ...currentTrivia,
        adminVisibility: visibility,
      });
    }
    if (this.state.surveyItem && String(this.state.surveyItem._id) === String(trivvyId)) {
      this.setState({
        surveyItem: { ...this.state.surveyItem, adminVisibility: visibility },
      });
    }
  };

  // Mirrors the row menu's move-model add: the BE $sets folderId, so the copy we
  // hold is patched in place rather than refetched.
  applyTrivvyFolderId = (folderId) => {
    const { currentTrivia } = this.props;
    if (currentTrivia) {
      this.props.setCurrentTrivia({ ...currentTrivia, folderId: folderId });
    }
    if (this.state.surveyItem) {
      this.setState({
        surveyItem: { ...this.state.surveyItem, folderId: folderId },
      });
    }
    this.setState({ moreActionsMobileOpen: false });
    this.loadTrivvyFolders(currentTrivia, true);
  };

  handleAddToFolder = (folderId) => {
    const { currentTrivia } = this.props;
    const category = this.folderCategoryFor(currentTrivia);
    if (!category || !currentTrivia || !currentTrivia._id) {
      return;
    }
    folderService
      .addItemToFolder(category, folderId, currentTrivia._id)
      .then(() => {
        this.applyTrivvyFolderId(folderId);
        toastContainer("Added to folder", "success");
      })
      .catch((err) => {
        console.log("add to folder failed", err);
        toastContainer(
          "Could not move the item to the folder. Please try again.",
          "error"
        );
      });
  };

  handleCreateFolderForTrivvy = () => {
    // The mobile sheet's backdrop sits far above the modal layer, so it has to
    // go before the name modal mounts or the modal renders behind it.
    this.setState({
      moreActionsMobileOpen: false,
      folderNameModal: { open: true },
    });
  };

  closeFolderNameModal = () => {
    this.setState({ folderNameModal: { open: false } });
  };

  handleFolderNameSave = (name) => {
    const { currentTrivia } = this.props;
    const category = this.folderCategoryFor(currentTrivia);
    if (!category) {
      return;
    }
    folderService
      .createFolder(category, name)
      .then((result) => {
        const newFolder = result && result.folder ? result.folder : null;
        this.setState({ folderNameModal: { open: false } });
        if (newFolder && newFolder._id && currentTrivia && currentTrivia._id) {
          return folderService
            .addItemToFolder(category, newFolder._id, currentTrivia._id)
            .then(() => {
              this.applyTrivvyFolderId(newFolder._id);
              toastContainer("Folder created — item added", "success");
            });
        }
        this.loadTrivvyFolders(currentTrivia, true);
        toastContainer("Folder created", "success");
        return null;
      })
      .catch((err) => {
        console.log("folder create failed", err);
        this.setState({ folderNameModal: { open: false } });
        toastContainer(
          "Could not create the folder. Please try again.",
          "error"
        );
      });
  };

  buildFolderProps = () => {
    const { currentTrivia } = this.props;
    const category = this.folderCategoryFor(currentTrivia);
    return {
      mode: "add",
      folders: this.state.folderList,
      membership: this.state.folderMembership,
      currentFolderId: null,
      memberFolderIds:
        currentTrivia && currentTrivia.folderId
          ? [String(currentTrivia.folderId)]
          : [],
      itemNoun: folderService.getFolderNoun(category),
      onSelect: this.handleAddToFolder,
      onCreateNew: this.handleCreateFolderForTrivvy,
      // The other entries in this menu are icon-indented; the row 3-dots menus
      // pass no icon and keep their plain-text trigger.
      leadingIcon: <BiFolder size={18} />,
    };
  };

  retrieveSearchPath = () => {
    const section = this.props.match.params.tab;
    if (!section) {
      this.setState({ menu: 1 });
      this.props.history.push("edit");
    } else {
      if (section === "edit") {
        this.setState({ menu: 1 });
      }
      if (section === "share") {
        this.setState({ menu: 2 });
      }
      if (section === "results") {
        this.setState({ menu: 3 });
      }
      if (section === "results-summary") {
        this.setState({ menu: 3 });
      }
      if (section === "results-responses") {
        this.setState({ menu: 3 });
      }
    }
  };

  openQuestionsList = () => {
    this.setState({ questionsListModal: true });
  };

  closeQuestionsList = () => {
    this.setState({ questionsListModal: false });
  };

  doPublish = (value, cb) => {
    const updateData = {
      isPublished: value,
    };

    if (
      moment(this.props.currentTrivia.trivvyEndDate).isSameOrBefore(
        moment(),
        "day"
      ) &&
      value == true
    ) {
      updateData.trivvyEndDate = null;
    }
    axios
      .put(url.updateTrivvyPublish(this.props.currentTrivia._id), {
        updateData: updateData,
      })
      .then(({ data }) => {
        this.props.setCurrentTrivia({
          ...this.props.currentTrivia,
          isPublished: value,
          publishedDate: data.data.trivia.publishedDate,
          unpublishedDate: data.data.trivia.unpublishedDate,
          trivvyEndDate: data.data.trivia.trivvyEndDate,
        });

        if (cb) {
          cb();
        }

        if (value == true) {
          dismissToast();
        }
      })
      .catch((err) => {
        console.log("pubErr", err);
        toastContainer("Error while updating Trivvy publish status.", "error");
      });
  };

  publishTriviaApiCall = (value, cb = null) => {
    // Before publishing, default empty linear scale labels. These are
    // respondent-facing (on screen and in the SMS linear prompt), so they follow
    // the Trivvy's own language rather than always defaulting to English.
    if (value === true && this.props.currentTrivia.questions) {
      const trivvyLanguage = this.props.currentTrivia.trivvyLanguage;
      const defaultMinLabel = getTextFromLanguageCodeAndKey(
        trivvyLanguage,
        "scaleMinLabel"
      );
      const defaultMaxLabel = getTextFromLanguageCodeAndKey(
        trivvyLanguage,
        "scaleMaxLabel"
      );
      let needsLabelUpdate = false;
      const that = this;
      const updatedQuestions = this.props.currentTrivia.questions.map(function(q) {
        if (q.question_type === "LINEAR_NUMERIC" && q.linearNumericConfigs) {
          const configs = q.linearNumericConfigs;
          const emptyMin = !configs.minLabel || configs.minLabel.trim() === "";
          const emptyMax = !configs.maxLabel || configs.maxLabel.trim() === "";
          if (emptyMin || emptyMax) {
            needsLabelUpdate = true;
            return {
              ...q,
              linearNumericConfigs: {
                ...configs,
                minLabel: emptyMin ? defaultMinLabel : configs.minLabel,
                maxLabel: emptyMax ? defaultMaxLabel : configs.maxLabel,
              },
            };
          }
        }
        return q;
      });

      if (needsLabelUpdate) {
        axios
          .put(url.editTrivia(this.props.currentTrivia._id), {
            updateData: { questions: updatedQuestions },
          })
          .then(function() {
            that.doPublish(value, cb);
          })
          .catch(function(err) {
            console.log("Error defaulting linear scale labels:", err);
            that.doPublish(value, cb);
          });
        return;
      }
    }

    this.doPublish(value, cb);
  };

  selectMenu = (menu) => {
    let menuText = "";
    if (menu === 1) {
      menuText = "edit";
    }
    if (menu === 2) {
      menuText = "share";
      if (
        this.state.surveyItem &&
        !this.state.surveyItem.isMessaging &&
        !this.state.surveyItem.isPublished
      )
        this.showSharedPublishNotification();
    }
    if (menu === 3) {
      this.getTrivvyForEditCall(true);
      menuText = "results";
    }
    this.props.history.push(menuText)
    this.setState({ menu })

    if (menu === 1 && this.state.surveyItem && !this.state.surveyItem.isMessaging && this.state.surveyItem.isPublished != true) {
      this.showPublishNotification()
    }
  }

  // Duplicate from inside a Trivvy. The list pages open the same modal from
  // their 3-dots menu; this is the second entry point the ticket asks for.
  openDuplicate = () => {
    this.setState({ duplicateModalOpen: true });
  };

  // Explicit close, not a toggle: the modal fires onClose a second after a
  // successful duplicate, and a toggle would flip it straight back open.
  closeDuplicate = () => {
    this.setState({ duplicateModalOpen: false });
  };

  // Match the lists: land on the new copy, which is what the admin just asked
  // for. The Trivvy being edited is saved as it goes, so nothing is lost.
  handleAfterDuplicate = (newTrivia) => {
    this.setState({ duplicateModalOpen: false });
    if (newTrivia && newTrivia._id) {
      this.props.history.push(
        `/home/trivia/${this.props.user.profile.organizationId._id}/edit/${newTrivia._id}/edit`
      );
    }
  };

  togglePreview = () => {
    this.props.history.push(
      `/home/trivia/${this.props.user.profile.organizationId._id}/preview-quiz/${this.state.surveyItem._id}/start`
    );
  };

  componentDidMount() {
    dismissToast();
    const paramsOrgId = this.props.match.params.orgId;
    const userOrgId = this.props.user.profile.organizationId._id;
    if (paramsOrgId == userOrgId && this.props.user.profile.role == "Admin") {
    } else {
      toastContainer(
        "This content is not available to you. Please ask your admin or login as a different user to access it.",
        "error"
      );
      this.props.history.push(
        `/home/trivia/${this.props.user.profile.organizationId._id}/list`
      );
    }
    const surveyId = this.props.match.params.id;
    this.retrieveSearchPath();
    // this.props.setCurrentQuiz(null);
    this.props.setCurrentQuestion(null);

    this.getTrivvyForEditCall(false);

    let orgId = this.props.user.profile.organizationId._id;

    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      this.props.orgChangeSuccess(payload);
    });
  }

  getTrivvyForEditCall = (noLoad, type) => {
    const surveyId =
      typeof noLoad == "string" ? noLoad : this.props.match.params.id;
    return axios
      .get(url.getTriviaForEdit(surveyId, noLoad))
      .then(({ data }) => {
        const survey_doc = {
          ...data.data.trivia,
          questions: formatQuestionsNumberWise(data.data.trivia.questions),
          trivvyHasResponses: data.data.trivvyHasResponses || false,
        };
        console.log("236 survey_doc -- ", survey_doc);

        this.setState({
          surveyItem: survey_doc,
          linkedRewards: data.data.linkedRewards,
          // A tab switch refetches without changing the route id, so the
          // componentWillReceiveProps reset never fires for it.
          nameDraft: null,
        });

        this.props.setCurrentTrivia(survey_doc)

        // The folder category is derived from the doc, so the folder list can
        // only be fetched once the doc has arrived.
        this.loadTrivvyFolders(survey_doc)

        // Fetch submissions for this survey
        this.fetchTriviaSubmissions(surveyId)

        if (
          survey_doc &&
          !survey_doc.isMessaging &&
          survey_doc.isPublished != true &&
          (this.props.match.params.tab === 'edit' || this.props.match.params.tab === 'share')
        ) {
          this.showPublishNotification()
        }

        const search = window.location.search;
        const params = new URLSearchParams(search);
        const autoPub = params.get("autoPublish");
        if (autoPub == true || autoPub == "true") {
          this.publishTriviaApiCall(true, null);
          // this.props.setCurrentTrivia({ ...survey_doc, isPublished: true });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   * Fetches submission data for the current trivia/survey
   * Used to determine if unpublish button should be disabled
   * @param {string} surveyId - The ID of the survey to fetch submissions for
   */
  fetchTriviaSubmissions = (surveyId) => {
    if (!surveyId) {
      console.log('No survey ID provided for submissions fetch')
      return
    }

    this.setState({ submissionsLoading: true, submissionsError: null, submissionsData: [] })

    axios
      .post(url.getTriviaSubmissions(surveyId), {
        filter: {},
      })
      .then(({ data }) => {
        const submissionsArray = data.data || []
        console.log('Submissions fetched for', surveyId, ':', submissionsArray.length, 'submissions')
        this.setState({
          submissionsData: submissionsArray,
          submissionsLoading: false,
        })
      })
      .catch((err) => {
        console.error('Error fetching trivia submissions:', err)
        this.setState({
          submissionsError: err,
          submissionsLoading: false,
          submissionsData: [],
        })
      })
  }

  
      
      
      
            
      
  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedFilters !== this.state.selectedFilters) {
    }
    // Navigating to a duplicate keeps this component mounted, so the fetch in
    // componentDidMount never re-runs and the page would keep showing the
    // source Trivvy's questions and welcome copy in the old language.
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.props.setCurrentQuestion(null);
      this.getTrivvyForEditCall(false);
    }
  }

  componentWillUnmount() {
    // Safety net for a keystroke the user never blurred away from.
    this.debounceAutoSaveData.flush();
    dismissToast();
    // toastContainer.dismiss()
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.currentTrivia) !==
      JSON.stringify(nextProps.currentTrivia)
    ) {
      this.setState({
        surveyItem: nextProps.currentTrivia,
      });
    }

    if (nextProps.match.params.id != this.props.match.params.id) {
      // Different Trivvy: a half-typed name from the previous one must not
      // survive into its title field.
      this.setState({ nameDraft: null });
      this.getTrivvyForEditCall(nextProps.match.params.id);
    }
  }

  showPublishToast = () => {
    if (this.props.currentTrivia && this.props.currentTrivia.isMessaging) {
      return;
    }
    toastContainer(
      <div onClick={() => {
            dismissToast()
            this.publishTriviaApiCall(true, () => this.selectMenu(2))
          }}>
        Ready to share your Trivvy? Click{" "}
        <b>
          here
        </b>{" "}
        publish your Trivvy & then share it
      </div>,
      // { background: "#eefaec", color: "#005300", fontSize: "14px" }
      {
        // Literal hex, not var(): the toast portals to document.body, outside
        // the .bwai-edit token scope. Values mirror the design tokens.
        background: "rgb(238 250 236)",
        color: "#334155",
        border: "1px solid #cfe8ca",
        fontSize: "14px",
        lineHeight: "1.6",
        borderRadius: "12px",
        boxShadow:
          "0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 12px 24px -6px rgba(15, 23, 42, 0.12)",
        right: isMobile ? "auto" : "85%",
        marginBottom: "0px",
      }
    );
  };

  showSharedPublishNotification = () => {
    const isFirstTime = this.state.surveyItem && !this.state.surveyItem.publishedDate && !this.state.surveyItem.unpublishedDate;
    const message = isFirstTime
      ? <div onClick={() => {
            dismissToast()
            this.publishTriviaApiCall(true, () => this.selectMenu(2))
          }}>Ready to Share your Trivvy? Click <b>here</b> to publish it.</div>
      : <div onClick={() => {
            dismissToast()
            this.publishTriviaApiCall(true, () => this.selectMenu(2))
          }}>You need to publish your Trivvy to be able to share it.</div>;

    toastContainer(
      message,
      {
        // Literal hex, not var(): the toast portals to document.body, outside
        // the .bwai-edit token scope. Values mirror the design tokens.
        background: "rgb(238 250 236)",
        color: "#334155",
        border: "1px solid #cfe8ca",
        fontSize: "14px",
        lineHeight: "1.6",
        borderRadius: "12px",
        boxShadow:
          "0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 12px 24px -6px rgba(15, 23, 42, 0.12)",
        right: isMobile ? 0 : "85%",
        marginBottom: "0px",
      }
    );
  };

  showPublishNotification = () => {
    toastContainer(
      <div
          onClick={() => {
            dismissToast()
            this.publishTriviaApiCall(true, () => this.selectMenu(2))
          }}>
        You can review and edit questions on the left-hand side or click{' '}
        <b>
          here
        </b>{' '}
        to publish and share your Trivvy.
      </div>,
      {
        // Literal hex, not var(): the toast portals to document.body, outside
        // the .bwai-edit token scope. Values mirror the design tokens.
        background: "rgb(238 250 236)",
        color: "#334155",
        border: "1px solid #cfe8ca",
        fontSize: "14px",
        lineHeight: "1.6",
        borderRadius: "12px",
        boxShadow:
          "0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 12px 24px -6px rgba(15, 23, 42, 0.12)",
        right: isMobile ? 0 : '85%',
        marginBottom: '0px',
      }
    )
  }

  editSurveyName = (val) => {
    // This input shows the title stripped, so the new text is folded back into
    // the stored markup — the edit page's styling survives a rename here too.
    if (val === getTrivvyTitleText(this.props.currentTrivia)) {
      return;
    }
    const nextName = applyTrivvyTitleText(
      this.props.currentTrivia && this.props.currentTrivia.name,
      val
    );
    this.props.setCurrentTrivia({
      ...this.props.currentTrivia,
      name: nextName,
    });

    // Mid-edit states like "" or "A" stay on screen but are never saved, so a
    // clear-and-retype never persists a one-character name.
    // cancel(), not just return: deleting past 2 chars would otherwise leave the
    // last valid keystroke armed, and ~3s later it saves "We" while the field
    // on screen reads "". Every keystroke used to re-arm the timer, so stored
    // and displayed could not diverge; skipping the re-arm reintroduces that.
    const trimmedText = typeof val === "string" ? val.trim() : "";
    if (trimmedText.length < 2) {
      this.debounceAutoSaveData.cancel();
      return;
    }

    this.debounceAutoSaveData("name", nextName);
  };

  callApiToAutoSave = (key, data) => {
    const payload = {
      [key]: data,
    };

    const { currentTrivia } = this.props;

    if (currentTrivia) {
      axios
        .put(url.editTrivia(currentTrivia._id), { updateData: payload })
        .then((res) => {
          console.log(res.data.data);
          if (payload.isPublished) {
            dismissToast();
          }
        })
        .catch((err) => console.log(err));
    }
  };

  debounceAutoSaveData = debounce(this.callApiToAutoSave, 3000);

  // Blur fires before the click that navigates away, so the rename is already
  // in flight when the next list mounts. The 3s debounce alone let that list's
  // fetch overtake the save and render the old name.
  commitSurveyName = () => {
    this.debounceAutoSaveData.flush();
  };

  afterLink = () => {
    const surveyId = this.props.match.params.id;
    this.retrieveSearchPath();
    // this.props.setCurrentQuiz(null);
    this.props.setCurrentQuestion(null);

    axios
      .get(url.getTriviaForEdit(surveyId, false))
      .then(({ data }) => {
        const survey_doc = {
          ...data.data.trivia,
          questions: formatQuestionsNumberWise(data.data.trivia.questions),
          trivvyHasResponses: data.data.trivvyHasResponses || false,
        };

        this.setState({
          surveyItem: survey_doc,
          linkedRewards: data.data.linkedRewards,
        });

        this.props.setCurrentTrivia(survey_doc);
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({ linkPopup: false });
  };

  menuNav = () => {
    let { currentTrivia } = this.props;

    if (currentTrivia) {
      let endUrl = "";
      if (currentTrivia && currentTrivia.triviaCategoryType == "REWARD") {
        endUrl = "/rewards";
      } else if (currentTrivia.isMessaging) {
        endUrl = "/messages";
      } else {
        endUrl = "/list";
      }
      let topMenuURL =
        "/home/trivia/" + this.props.user.profile.organizationId._id + endUrl;

      console.log("topMenuURL ---", topMenuURL);

      return this.props.history.push(topMenuURL);
    }
  };

  exportConvoPDF = async () => {
    const { renderInPage } = this.props;
    // console.log(this.state.exporting,document.querySelector("#jspdf_export_conversation"))
    // const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await document.querySelector("#jspdf_export_trivvy");

    // Page margins per the CTO spec (same as the Message download, bug843): top
    // 1in, left 1in, bottom 0.75in, right 0.75in. html2pdf's margin array is
    // [top, left, bottom, right] in the jsPDF unit, which DEFAULTS TO MILLIMETRES
    // — so the unit is set to inches explicitly, otherwise these would mean 1mm.
    // pagebreak keeps each question whole: html2pdf honors page-break-inside:
    // avoid on the elements matched by `pagebreak.avoid`, so a question + its
    // options move to the next page instead of splitting across the boundary.
    const pdf = window
      .html2pdf()
      .set({
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        margin: [1, 1, 0.75, 0.75],
        pagebreak: { mode: ["css", "legacy"], avoid: ".jpx-question-block" },
      })
      .from(data);

    // pdf.setFont("Arial", "normal");
    // pdf.setLanguage("mr")

    // pdf.html(data,{
    //   fontFaces:[
    //     {family:"Arial, Roboto, sans-serif"
    //   }]
    // })

    pdf.then(async () => {
      this.setState({ exporting: false });

      if (renderInPage) {
        // pdf.save(
        //   `${moment(new Date()).format(
        //     "dddd, MMMM Do YYYY, h:mm:ss a"
        //   )} - dani.pdf`
        // );
      } else {
        var string = await pdf.output("datauristring");
        console.log(string);
        var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
        var x = window.open();
        x.document.open();
        x.document.write(embed);

        var a = document.createElement("A");
        var filePath = await pdf.output("datauristring");
        a.href = filePath;
        // Strip first: the title is rich text, so a raw name produced
        // "pTitlep.pdf" — the regex drops < > but not the tag names.
        const safeFileName =
          (getTrivvyTitleText(this.props.currentTrivia) || "trivvy").replace(
            /[\\/:*?"<>|]/g,
            ""
          ).trim() || "trivvy";
        a.download = `${safeFileName}.pdf`;
        document.body.appendChild(a);
        setTimeout(() => {
          a.click();
          document.body.removeChild(a);
          x.close();
        }, 700);
      }
    });
  };

  exportMessagePDF = async () => {
    const node = document.querySelector("#jspdf_export_message");
    if (!node) {
      return;
    }
    const rawName = getTrivvyTitleText(this.props.currentTrivia);
    const safeName = rawName.replace(/[\\/:*?"<>|]/g, "").trim() || "message";
    // Page margins per the CTO spec (bug843): top 1in, left 1in, bottom 0.75in,
    // right 0.75in. html2pdf's margin array is [top, left, bottom, right] and is
    // expressed in the jsPDF unit, which DEFAULTS TO MILLIMETRES — so the unit is
    // set to inches explicitly, otherwise these numbers would mean 1mm / 0.75mm.
    // Page format stays the library default (a4), unchanged by this fix.
    await window
      .html2pdf()
      .set({
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        margin: [1, 1, 0.75, 0.75],
      })
      .from(node)
      .save(`${safeName}.pdf`);
  };

  toggleButtonDropdown = () => {
    this.setState({
      buttonDrodownOpen: !this.state.buttonDrodownOpen,
    });
  };

  updateTrivvyLinkedRewards = (data) => {
    this.setState({
      linkedRewards: data,
    });
  };

  render() {
    const {
      surveyItem,
      menu,
      isPreview,

      linkPopup,
      linkedRewards,
      manualReminderModal,
      advanceSettingsModal,
      buttonDrodownOpen,
      fontsModalOpen,
      questionsListModal,
      selectedFilters,
    } = this.state;

    const { currentTrivia } = this.props;

    let isEditable = currentTrivia && currentTrivia.isPublished;
    let adminRestricted = false;

    if (currentTrivia && currentTrivia.createdBy) {
      if (
        currentTrivia &&
        currentTrivia.createdBy._id != this.props.user.profile._id
      ) {
        if (!currentTrivia.isPublished) {
          isEditable = true;
        }

        adminRestricted = true;
      }

      if (
        this.props.user.profile.orgAdmin ||
        this.props.user.profile.role == "Admin"
      ) {
        if (!currentTrivia.isPublished) {
          isEditable = false;
        }
        adminRestricted = false;
      }
    }

    const planType = this.props.user.profile.organizationId.trivvyPlanType;

    let publishDisable = false;
    let unPublishDisable = false;
    let endDisable = false;
    let buttonText = "";

    const { submissionsData } = this.state
    const hasSubmissions = submissionsData && submissionsData.length > 0
    const isEditDisabled = currentTrivia && currentTrivia.isPublished && hasSubmissions;

    if (currentTrivia) {
      if (currentTrivia.isPublished) {
        publishDisable = true;
      }

      if (!currentTrivia.isPublished) {
        unPublishDisable = true;
      }
      // If there are submissions and respondents, disable unpublish to prevent data loss
      if (hasSubmissions && currentTrivia.isPublished) {
        unPublishDisable = true
      }

      if (currentTrivia.trivvyEndDate) {
        if (moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())) {
          endDisable = true;
          publishDisable = false;
          unPublishDisable = false;
        }
      }

      if (
        currentTrivia.trivvyEndDate &&
        moment(currentTrivia.trivvyEndDate).isSameOrBefore(moment())
      ) {
        buttonText = "Ended";
      } else if (currentTrivia.isPublished) {
        buttonText = "Published";
      } else {
        buttonText = "Unpublished";
      }
    }

    const isMessagingTrivvy = currentTrivia && currentTrivia.isMessaging;
    const isOneWayMessagingTrivvy =
      currentTrivia &&
      currentTrivia.isMessaging &&
      currentTrivia.isOneWay === true;

    // Mobile Results > Insights sub-tab → show the Figma insights header above
    // the Edit/Share/Results tabs (instead of the breadcrumb), for every trivvy
    // type. Sub-tab is read from the URL since this component only tracks the
    // top-level menu.
    const resultsSubtab =
      this.props.match && this.props.match.params
        ? this.props.match.params.tab
        : "";
    const showInsightsHeader =
      isMobile &&
      menu === 3 &&
      (resultsSubtab === "results-insights" || resultsSubtab === "results");
    const insightsHeaderTitle = isMessagingTrivvy
      ? "Message Insights"
      : currentTrivia && currentTrivia.triviaCategoryType === "KNOWLEDGE_CHECK"
        ? "Knowledge Check Insights"
        : "Survey Insights";
    // A published Message keeps the editable name pill; every other published
    // Trivvy still falls through to the flat read-only title.
    const isPublishedMessage =
      currentTrivia && currentTrivia.isPublished && isMessagingTrivvy;
    let nameInputDisabled = isEditable;
    if (isPublishedMessage) {
      nameInputDisabled = adminRestricted;
    }

    return (
      <div className="trivia_survey_edit_page bwai-edit">
        {linkPopup && currentTrivia ? (
          <LinkTriviaRewardPopup
            currentTrivia={currentTrivia}
            selectedItems={linkedRewards}
            open={linkPopup}
            onClose={() => this.setState({ linkPopup: false })}
            trivia={currentTrivia}
            setSelectedItems={this.updateTrivvyLinkedRewards}
          />
        ) : (
          ""
        )}
        <div
          className={`survey-top-div ${!isMobile && ""} ${
            isMessagingTrivvy ? "messaging-bar" : ""
          }`}
        >
          {surveyItem && (
            <Row
              className={`survey_detail_page_top_navbar bg-white pl-2 mx-0 ${
                isMobile ? "mx-0" : ""
              } ${!isMobile && "pl-3"}`}
            >
              {currentTrivia && (
                <div
                  style={{
                    display: "none",
                  }}
                >
                  <div id="jspdf_export_trivvy">
                    <div>
                      <h1 className="mt-2 jpx-title">{parse(currentTrivia.name || "")}</h1>

                      {currentTrivia.welcomePage &&
                      currentTrivia.welcomePage.heading &&
                      currentTrivia.welcomePage.heading.replace(/<[^>]*>/g, "").trim() ? (
                        <div className="jpx-subtitle">
                          {parse(currentTrivia.welcomePage.heading)}
                        </div>
                      ) : null}
                      {currentTrivia.welcomePage &&
                      currentTrivia.welcomePage.description &&
                      currentTrivia.welcomePage.description.replace(/<[^>]*>/g, "").trim() &&
                      currentTrivia.welcomePage.description !== currentTrivia.welcomePage.heading ? (
                        <div className="jpx-subdescription">
                          {parse(currentTrivia.welcomePage.description)}
                        </div>
                      ) : null}

                      {/* <div className="text-center mt-2 mb-4">
                        ({currentTrivia.organizationId}-{currentTrivia._id})
                      </div> */}

                      <div>
                        {currentTrivia.questions &&
                          currentTrivia.questions.length &&
                          currentTrivia.questions.map((question, index) => {
                            return (
                              <div
                                key={question._id || index}
                                className="mt-3 jpx-question-block"
                              >
                                <h4 className="jpx-question">
                                  {index + 1}) {parse(question.question_text)}
                                </h4>
                                {question.question_type == "LINEAR_NUMERIC" && (
                                  <div className="my-2 jpx-linear-hint">
                                    {question.linearNumericConfigs &&
                                    question.linearNumericConfigs.min &&
                                    question.linearNumericConfigs.max ? (
                                      <span>
                                        Give answer in range of{" "}
                                        {question.linearNumericConfigs.min} -{" "}
                                        {question.linearNumericConfigs.max}{" "}
                                      </span>
                                    ) : (
                                      " Give answer"
                                    )}
                                  </div>
                                )}

                                {question.question_type === "LINEAR_NUMERIC" ? (
                                  <div className="mt-3 jpx-linear-scale">
                                    <RangeInput
                                      min={question.linearNumericConfigs.min}
                                      max={question.linearNumericConfigs.max}
                                      value={null}
                                      onChange={(value) => {}}
                                      themeSettings={
                                        currentTrivia.themeSettings ||
                                        THEME_SETTING
                                      }
                                    />
                                  </div>
                                ) : question.question_type === "TEXT" ? (
                                  <div className="mt-3">
                                    <Input type="textarea" rows={2} />
                                  </div>
                                ) : question.question_type === "MCQ" ? (
                                  <div className="mt-3">
                                    <ol className="jpx-option-list">
                                      {question.options &&
                                        question.options.length &&
                                        question.options.map((option, idx) => {
                                          return (
                                            <li
                                              key={option.option_id || idx}
                                              className="jpx-option"
                                            >
                                              <span className="jpx-option-num">
                                                {idx + 1}.
                                              </span>
                                              {parse(trimDisplayText(option.text))}
                                            </li>
                                          );
                                        })}
                                    </ol>
                                  </div>
                                ) : question.question_type === "CHECKBOX" ? (
                                  <div className="mt-3">
                                    {question.options &&
                                      question.options.length &&
                                      question.options.map((option, idx) => {
                                        const isCorrect =
                                          question.correct_options &&
                                          question.correct_options.some(
                                            (c) => c.option_id == option.option_id
                                          );
                                        return (
                                          <div key={idx} className="d-flex align-items-center my-1">
                                            <input
                                              type="checkbox"
                                              checked={!!isCorrect}
                                              disabled
                                              readOnly
                                              className="mr-2"
                                            />
                                            <span className="jpx-option">
                                              {parse(trimDisplayText(option.text))}
                                            </span>
                                          </div>
                                        );
                                      })}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isMessagingTrivvy && currentTrivia && (
                <div
                  style={{
                    display: "none",
                  }}
                >
                  <div id="jspdf_export_message">
                    <h1 className="jmx-title">{parse(currentTrivia.name || "")}</h1>
                    <div className="jmx-body">
                      {/* Legacy plain bodies keep the exact-spacing renderer so
                          indents and column alignment survive as they did. */}
                      {isRichMessageBody(currentTrivia.messagingSubject)
                        ? parse(
                            sanitizeMessageBodyHtml(
                              currentTrivia.messagingSubject
                            )
                          )
                        : messageTextPreserveSpacing(
                            currentTrivia.messagingSubject
                          )}
                    </div>
                  </div>
                </div>
              )}

              <Col md={3} className={isMobile ? "pl-4" : "pl-0"}>
                {showInsightsHeader ? (
                  <div className="pt-2 msg-insights-mobile-header">
                    <div className="msg-insights-mobile-title">{insightsHeaderTitle}</div>
                    <div className="msg-insights-mobile-sub">
                      {getTrivvyTitleText(surveyItem)} · as of{" "}
                      {moment().format("MMM D, YYYY")}
                    </div>
                  </div>
                ) : (
                <div className="pt-2 d-flex bwai-edit-name-row">
                  <span
                    className="survey_detail_page_top_wp"
                    onClick={() => this.menuNav()}
                    // data-tip={TRIVIA_DESCRIPTION}
                    data-for="trivvy_edit_title"
                  >
                    {isMessagingTrivvy ? "Messages" : "Trivvy"}
                    {/* My Workspace{" "} */}
                  </span>{" "}
                  {/* <ReactTooltip id="trivvy_edit_title" place="right" /> */}-
                  {currentTrivia &&
                  currentTrivia.isPublished &&
                  !isMessagingTrivvy ? (
                    <span className="ml-2 trivvy_title_ellipsis">
                      {getTrivvyTitleText(surveyItem)}
                    </span>
                  ) : currentTrivia &&
                    (!currentTrivia.isPublished || isMessagingTrivvy) ? (
                    <span className="bwai-edit-name-pill">
                      <input
                        value={
                          this.state.nameDraft !== null
                            ? this.state.nameDraft
                            : getTrivvyTitleText(surveyItem)
                        }
                        onChange={(e) => {
                          this.setState({ nameDraft: e.target.value });
                          this.editSurveyName(e.target.value);
                        }}
                        onBlur={() => this.commitSurveyName()}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.target.blur();
                          }
                        }}
                        className="survey_detail_page_top_name"
                        disabled={nameInputDisabled}
                        maxLength={100}
                        style={{
                          position: "relative",
                          flex: 1,
                          color:
                            currentTrivia &&
                            currentTrivia.isPublished &&
                            !isMessagingTrivvy
                              ? "#262627"
                              : "",
                          borderColor:
                            currentTrivia &&
                            currentTrivia.isPublished &&
                            !isMessagingTrivvy
                              ? "transparent"
                              : "",
                        }}
                      />
                      {/* Inside the pill per the mock. The tooltip keeps the
                          affordance the floating "Edit" label used to carry. */}
                      <small
                        data-for="trivvy_edit_title2"
                        data-tip="Edit Trivvy title"
                        className="survey_detail_page_top_name_highlight"
                      >
                        <LuPencil />
                      </small>
                    </span>
                  ) : (
                    ""
                  )}{" "}
                  <ReactTooltip id="trivvy_edit_title2" place="right" />
                </div>
                )}
              </Col>
              <Col
                md={6}
                className={`${
                  isMobile ? "mt-4" : ""
                } d-flex justify-content-center`}
              >
                <ul className="data-user trivia-edit-top-nav-survey-ui bwai-edit-tabs">
                  {/* {!isMessagingTrivvy && (
                    <li>
                      {" "}
                      <a
                        className={`${
                          menu == 1 ? "profile_page_menu_option_active" : ""
                        }`}
                        onClick={() => this.selectMenu(1)}
                      >
                        Edit
                      </a>{" "}
                    </li>
                  )} */}

{/* CEO: the edit page is hidden on mobile, so drop the Edit tab there. */}
                  {!isMobile && (
                    <li>
                      {' '}
                      <a
                        className={`${
                          menu == 1 ? 'profile_page_menu_option_active' : ''
                        }`}
                        onClick={() => this.selectMenu(1)}>
                        Edit
                      </a>{' '}
                    </li>
                  )}

                  <li>
                    <a
                      className={`${
                        menu == 2 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.selectMenu(2)}
                    >
                      Share
                    </a>
                  </li>

                  {!isOneWayMessagingTrivvy && (
                    <li>
                      <a
                        className={`${
                          menu == 3 ? "profile_page_menu_option_active" : ""
                        }`}
                        onClick={() => this.selectMenu(3)}
                      >
                        Results
                      </a>
                    </li>
                  )}
                </ul>
              </Col>

              <Col
                md={3}
                style={{
                  display: isMobile ? (menu != 3 ? "flex" : "none") : "flex",
                }}
                className="text-center trivi-edit-top-menu-button-grp pl-0"
              >
                {currentTrivia &&
                  currentTrivia.questions &&
                  !isMessagingTrivvy &&
                  currentTrivia.questions.length &&
                  questionsListModal && (
                    <QuestionsListModal
                      open={questionsListModal}
                      onClose={this.closeQuestionsList}
                      currentTrivia={currentTrivia}
                    />
                  )}

                {advanceSettingsModal && currentTrivia && (
                  <AdvanceTrivvySettingModal
                    onlyShowMessagingSettings={isMessagingTrivvy}
                    open={advanceSettingsModal}
                    onClose={() =>
                      this.setState({
                        advanceSettingsModal: false,
                      })
                    }
                    trivia={currentTrivia}
                    setCurrentTrivia={this.props.setCurrentTrivia}
                    saveData={this.callApiToAutoSave}
                    user={this.props.user}
                  />
                )}

                {isMessagingTrivvy && isMobile ? (
                  <>
                    <ButtonDropdown
                      className="ml-2 mr-2 mb-2"
                      isOpen={false}
                      toggle={() =>
                        this.setState({
                          moreActionsMobileOpen: !this.state.moreActionsMobileOpen,
                        })
                      }
                    >
                      <DropdownToggle
                        className="pr-4 trivia-edit-btn-height bwai-edit-toolbar-btn"
                        color={"secondary"}
                        size="sm"
                        caret
                      >
                        More actions
                      </DropdownToggle>
                    </ButtonDropdown>
                    {this.state.moreActionsMobileOpen &&
                      ReactDOM.createPortal(
                        <div
                          className="more-actions-mobile-backdrop"
                          onClick={() =>
                            this.setState({ moreActionsMobileOpen: false })
                          }
                        >
                          <div
                            className="more-actions-mobile-sheet"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              onClick={() => {
                                this.setState({ moreActionsMobileOpen: false });
                                this.exportMessagePDF();
                              }}
                            >
                              <BsDownload size={18} /> Download Message
                            </button>
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              onClick={() =>
                                this.setState({
                                  advanceSettingsModal: true,
                                  moreActionsMobileOpen: false,
                                })
                              }
                            >
                              <BsFillGearFill size={18} /> Advanced Settings
                            </button>
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              onClick={() => {
                                this.setState({ moreActionsMobileOpen: false });
                                this.togglePreview();
                              }}
                            >
                              <BsFillEyeFill size={17} /> Preview
                            </button>
                            <TrivvyMoreActionsItems
                              variant="sheet"
                              item={currentTrivia}
                              user={this.props.user}
                              onAction={this.openMoreAction}
                              folderProps={this.buildFolderProps()}
                            />
                          </div>
                        </div>,
                        document.body
                      )}
                  </>
                ) : isMessagingTrivvy ? (
                  <UncontrolledButtonDropdown
                    className="ml-2 mr-2 mb-2"
                    direction={isMobile ? "right" : "down"}
                  >
                    <DropdownToggle
                      className="pr-4 trivia-edit-btn-height bwai-edit-toolbar-btn"
                      color={"secondary"}
                      size="sm"
                      caret
                    >
                      More actions
                    </DropdownToggle>
                    <DropdownMenu className="bwai-edit-menu" style={{ zIndex: "99999999999" }}>
                      <DropdownItem
                        onClick={() => {
                          this.exportMessagePDF();
                        }}
                      >
                        <BsDownload size={18} /> Download Message
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          this.setState({ advanceSettingsModal: true })
                        }
                      >
                        <BsFillGearFill size={18} /> Advanced Settings
                      </DropdownItem>
                      <DropdownItem onClick={this.togglePreview}>
                        <BsFillEyeFill size={17} /> Preview
                      </DropdownItem>
                      <DropdownItem onClick={this.openDuplicate}>
                        <BsFiles size={17} /> Duplicate
                      </DropdownItem>
                      <TrivvyMoreActionsItems
                        variant="dropdown"
                        item={currentTrivia}
                        user={this.props.user}
                        onAction={this.openMoreAction}
                        folderProps={this.buildFolderProps()}
                      />
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                ) : isMobile ? (
                  <>
                    <ButtonDropdown
                      className="ml-2 mr-2 mb-2"
                      isOpen={false}
                      toggle={() =>
                        this.setState({
                          moreActionsMobileOpen: !this.state.moreActionsMobileOpen,
                        })
                      }
                    >
                      <DropdownToggle
                        className="pr-4 trivia-edit-btn-height more-actions-bg"
                        color={"secondary"}
                        size="sm"
                        caret
                      >
                        More actions
                      </DropdownToggle>
                    </ButtonDropdown>
                    {this.state.moreActionsMobileOpen &&
                      ReactDOM.createPortal(
                        <div
                          className="more-actions-mobile-backdrop"
                          onClick={() =>
                            this.setState({ moreActionsMobileOpen: false })
                          }
                        >
                          <div
                            className="more-actions-mobile-sheet"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {isMessagingTrivvy ? (
                              <button
                                type="button"
                                className="more-actions-mobile-item"
                                onClick={() =>
                                  this.setState({
                                    advanceSettingsModal: true,
                                    moreActionsMobileOpen: false,
                                  })
                                }
                              >
                                <BsFillGearFill size={18} /> Advanced settings
                              </button>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  className="more-actions-mobile-item"
                                  onClick={() => {
                                    this.setState({ moreActionsMobileOpen: false });
                                    this.exportConvoPDF();
                                  }}
                                >
                                  <BsDownload size={18} /> Download Questions
                                </button>
                                <button
                                  type="button"
                                  className="more-actions-mobile-item"
                                  onClick={() =>
                                    this.setState({
                                      advanceSettingsModal: true,
                                      moreActionsMobileOpen: false,
                                    })
                                  }
                                >
                                  <BsFillGearFill size={18} /> Advanced Settings
                                </button>
                                {currentTrivia &&
                                currentTrivia.isPublished &&
                                currentTrivia.sharedWithUsers &&
                                currentTrivia.sharedWithUsers.length ? (
                                  <button
                                    type="button"
                                    className="more-actions-mobile-item"
                                    onClick={() =>
                                      this.setState({
                                        manualReminderModal: true,
                                        moreActionsMobileOpen: false,
                                      })
                                    }
                                  >
                                    <BsAlarmFill size={18} /> Remind Users
                                  </button>
                                ) : null}
                                <button
                                  type="button"
                                  className="more-actions-mobile-item"
                                  onClick={() => {
                                    this.setState({ moreActionsMobileOpen: false });
                                    this.togglePreview();
                                  }}
                                >
                                  <BsFillEyeFill size={17} /> Preview
                                </button>
                              </>
                            )}
                          </div>
                        </div>,
                        document.body
                      )}
                  </>
                ) : (
                  <UncontrolledButtonDropdown
                    className="ml-2 mr-2 mb-2"
                    direction={"down"}
                  >
                    <DropdownToggle
                      className="pr-4 trivia-edit-btn-height bwai-edit-toolbar-btn"
                      color={"secondary"}
                      size="sm"
                      caret
                    >
                      More actions
                    </DropdownToggle>
                      <DropdownMenu className="bwai-edit-menu" style={{ zIndex: "99999999999" }}>
                        <DropdownItem
                          onClick={() => {
                            this.exportConvoPDF();
                          }}
                        >
                          <BsDownload size={18} /> Download Questions
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            this.setState({ advanceSettingsModal: true })
                          }
                        >
                          <BsFillGearFill size={18} /> Advanced Settings
                        </DropdownItem>

                        {/* TODO bug###: re-enable when reminder feature is fixed */}
                        {/* {currentTrivia &&
                        currentTrivia.isPublished &&
                        currentTrivia.sharedWithUsers &&
                        currentTrivia.sharedWithUsers.length ? (
                          <DropdownItem
                            onClick={() =>
                              this.setState({ manualReminderModal: true })
                            }
                          >
                            <BsAlarmFill size={18} /> Remind Users
                          </DropdownItem>
                        ) : (
                          ""
                        )} */}

                        {/* {planType != '001' && (
                          <DropdownItem
                            onClick={() => this.setState({ linkPopup: true })}
                          >
                            <GiOpenTreasureChest size={18} /> Rewards
                          </DropdownItem>
                        )} */}

                        <DropdownItem onClick={this.togglePreview}>
                          <BsFillEyeFill size={17} /> Preview
                        </DropdownItem>
                        <DropdownItem onClick={this.openDuplicate}>
                          <BsFiles size={17} /> Duplicate
                        </DropdownItem>
                        <TrivvyMoreActionsItems
                          variant="dropdown"
                          item={currentTrivia}
                          user={this.props.user}
                          onAction={this.openMoreAction}
                          folderProps={this.buildFolderProps()}
                        />
                      </DropdownMenu>
                  </UncontrolledButtonDropdown>
                )}

                <TrivvyMoreActionsModals
                  action={this.state.moreAction.type}
                  item={this.state.moreAction.item}
                  isMessaging={Boolean(isMessagingTrivvy)}
                  onClose={this.closeMoreAction}
                  onDeleted={this.handleTrivvyDeleted}
                  onPrivacyUpdated={this.handleTrivvyPrivacyUpdated}
                />

                {this.state.folderNameModal.open && (
                  <FolderNameModal
                    open={this.state.folderNameModal.open}
                    title="Create folder"
                    subtitle={`Group related ${folderService.getFolderNoun(
                      this.folderCategoryFor(currentTrivia)
                    )} by team, location, campaign, or topic.`}
                    confirmLabel="Create folder"
                    initialName=""
                    onClose={this.closeFolderNameModal}
                    onSave={this.handleFolderNameSave}
                  />
                )}

                {manualReminderModal && (
                  <ManualRemindersModal
                    open={manualReminderModal}
                    triviaData={currentTrivia}
                    onClose={() => {
                      this.setState({
                        manualReminderModal: false,
                      });
                    }}
                  />
                )}

                {!isMessagingTrivvy && isMobile ? (
                  <>
                    <ButtonDropdown
                      className="ml-3 w-100 trivia-edit-btn-height mb-2"
                      isOpen={false}
                      toggle={this.toggleButtonDropdown}
                    >
                      <DropdownToggle
                        color={
                          buttonText == "Published"
                            ? "success"
                            : buttonText == "Ended"
                            ? "danger"
                            : "secondary"
                        }
                        className="text-center"
                        size="sm"
                        caret
                        disabled={adminRestricted}
                      >
                        {buttonText}
                      </DropdownToggle>
                    </ButtonDropdown>
                    {buttonDrodownOpen &&
                      ReactDOM.createPortal(
                        <div
                          className="more-actions-mobile-backdrop"
                          onClick={this.toggleButtonDropdown}
                        >
                          <div
                            className="more-actions-mobile-sheet"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              style={publishDisable ? { opacity: 0.35, cursor: "not-allowed", background: "transparent" } : {}}
                              onClick={() => {
                                if (publishDisable) return;
                                this.toggleButtonDropdown();
                                const callBackCode = () => {
                                  if (
                                    this.props.currentTrivia.scheduledDate &&
                                    !this.props.currentTrivia.firstPublishedDate
                                  ) {
                                    const { currentTrivia } = this.props;
                                  }
                                };
                                this.publishTriviaApiCall(true, callBackCode);
                              }}
                            >
                              Publish
                            </button>
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              style={unPublishDisable ? { opacity: 0.35, cursor: "not-allowed", background: "transparent" } : {}}
                              onClick={() => {
                                if (unPublishDisable) return;
                                this.toggleButtonDropdown();
                                this.publishTriviaApiCall(false, null);
                                this.showPublishToast();
                              }}
                            >
                              Unpublish
                            </button>
                            <button
                              type="button"
                              className="more-actions-mobile-item"
                              style={endDisable ? { opacity: 0.35, cursor: "not-allowed", background: "transparent" } : {}}
                              onClick={() => {
                                if (endDisable) return;
                                this.toggleButtonDropdown();
                                const date = moment().startOf("day");
                                this.props.setCurrentTrivia({
                                  ...currentTrivia,
                                  trivvyEndDate: date,
                                });
                                this.callApiToAutoSave("trivvyEndDate", date);
                              }}
                            >
                              End Trivvy
                            </button>
                          </div>
                        </div>,
                        document.body
                      )}
                  </>
                ) : !isMessagingTrivvy ? (
                  <ButtonDropdown
                    isOpen={buttonDrodownOpen}
                    toggle={this.toggleButtonDropdown}
                    className="ml-3 w-100 trivia-edit-btn-height mb-2"
                    direction="down"
                  >
                    <DropdownToggle
                      color={
                        buttonText == "Published"
                          ? "success"
                          : buttonText == "Ended"
                          ? "danger"
                          : "secondary"
                      }
                      className="text-center bwai-edit-toolbar-btn bwai-edit-publish-toggle"
                      size="sm"
                      caret
                      disabled={adminRestricted}
                    >
                      {buttonText}
                    </DropdownToggle>
                    <DropdownMenu className="bwai-edit-menu" style={{ zIndex: "99999999999" }}>
                      <DropdownItem
                        onClick={() => {
                          const callBackCode = () => {
                            if (
                              this.props.currentTrivia.scheduledDate &&
                              !this.props.currentTrivia.firstPublishedDate
                            ) {
                              const { currentTrivia } = this.props;
                            }
                          };
                          this.publishTriviaApiCall(true, callBackCode);
                        }}
                        disabled={publishDisable}
                      >
                        Publish
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          this.publishTriviaApiCall(false, null);
                          this.showPublishToast();
                        }}
                        disabled={unPublishDisable}
                      >
                        Unpublish
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          const date = moment().startOf("day");

                          this.props.setCurrentTrivia({
                            ...currentTrivia,
                            trivvyEndDate: date,
                          });
                          this.callApiToAutoSave("trivvyEndDate", date);
                        }}
                        disabled={endDisable}
                      >
                        End Trivvy
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                ) : null}

                {/* <span
                  data-tip={
                    publishDisabled(currentTrivia)
                      ? "Publish will be disabled until you set correct option for all questions"
                      : "Publish"
                  }
                >
                  <Button
                    size="sm"
                    // color={surveyItem.isPublished ? "":"success"}
                    color={surveyItem.isPublished ? "success" : "secondary"}
                    className={`ml-2 trivia-edit-menu-publish-btn  ${
                      surveyItem.isPublished
                        ? "trivvy-btn-published"
                        : "trivvy-btn-not-published"
                    }`}
                    disabled={publishDisabled(currentTrivia)}
                    // surveyItem.isPublished ? outline: ''
                    // outline
                    onClick={() => {
                      // if(!surveyItem.isPublished){
                      this.callApiToAutoSave(
                        "isPublished",
                        !surveyItem.isPublished
                      );
                      this.props.setCurrentTrivia({
                        ...this.props.currentTrivia,
                        isPublished: !surveyItem.isPublished,
                      });
                      // }else{

                      // }
                    }}
                  >
                    {surveyItem.isPublished ? "Published" : "Publish ?"}
                  </Button>
                </span> */}

                <ReactTooltip />
              </Col>
            </Row>
          )}

          {surveyItem && this.props.currentTrivia && (
            <div
              className={isMobile ? "px-2" : "handle-less-width-main-edit"}
              style={{
                position: 'relative',
                top: isMobile ? '62px' : '65px',
              }}>
              {this.state.duplicateModalOpen && surveyItem ? (
                <DuplicateTriviaPopup
                  open={this.state.duplicateModalOpen}
                  onClose={this.closeDuplicate}
                  item={surveyItem}
                  afterDuplicateSuccess={this.handleAfterDuplicate}
                  isMessaging={surveyItem.isMessaging === true}
                  isKc={surveyItem.triviaCategoryType === "KNOWLEDGE_CHECK"}
                  canTranslate={minPlanLimitCheck(
                    this.props.user &&
                      this.props.user.profile &&
                      this.props.user.profile.organizationId &&
                      this.props.user.profile.organizationId.trivvyPlanType,
                    '003'
                  )}
                />
              ) : (
                ''
              )}
              {menu === 1 ? 
                  surveyItem.isMessaging?
                    <MessagesEditViewListUI
                      key={surveyItem && surveyItem._id}
                      showPopupModal={() => this.setState({ linkPopup: true })}
                      linkedRewards={linkedRewards}
                      setAdvanceSettingModal={(val) => {
                        this.setState({ advanceSettingsModal: val })
                      }}
                      planType={planType}
                      publishTriviaApiCall={this.publishTriviaApiCall}
                      {...this.props}
                    />
                    :
                    <TriviaEditViewListUI
                      key={surveyItem && surveyItem._id}
                      showPopupModal={() => this.setState({ linkPopup: true })}
                      linkedRewards={linkedRewards}
                      setAdvanceSettingModal={(val) => {
                        this.setState({ advanceSettingsModal: val })
                      }}
                      planType={planType}
                      publishTriviaApiCall={this.publishTriviaApiCall}
                      {...this.props}
                    />
              : menu === 2 ? (
                <NewShareTriviaComponent
                  user={this.props.user}
                  surveyId={this.props.currentTrivia._id}
                  // setCurrentQuestion={this.props.setCurrentQuestion}
                  survey={this.props.currentTrivia}
                  editCurrentTriviaShareData={
                    this.props.editCurrentTriviaShareData
                  }
                  setCurrentTrivia={this.props.setCurrentTrivia}
                  callApiToAutoSave={this.callApiToAutoSave}
                  publishTriviaApiCall={this.publishTriviaApiCall}
                  showPublishToast={this.showPublishToast}
                  {...this.props}
                />
              ) : isOneWayMessagingTrivvy ? (
                <div className="text-center mt-5">
                  <p>Results are not available for 1-way messages.</p>
                </div>
              ) : (
                <TriviaResultsComponent
                  currentTrivia={this.props.currentTrivia}
                  setCurrentTrivia={this.props.setCurrentTrivia}
                  getTrivvyForEditCall={(type) =>
                    this.getTrivvyForEditCall(false, type)
                  }
                  {...this.props}
                  messageInsightsOpen={this.state.messageInsightsOpen}
                  setMessageInsightsOpen={(v) =>
                    this.setState({ messageInsightsOpen: v })
                  }
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    currentTrivia: state.trivia.currentTrivia,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    setCurrentQuiz: (data) => dispatch(actionCreators.setCurrentQuiz(null)),
    setCurrentQuestion: (data) =>
      dispatch(actionCreators.setCurrentQuestion(null)),
    resetTrivia: (data) => dispatch(actionCreators.resetTrivia(data)),
    editCurrentTriviaShareData: (data) =>
      dispatch(actionCreators.editCurrentTriviaShareData(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaEdit, axios));
